<template>
    <div class="fixed_footer_wrapper">
        <div id="footer-wrapper" ref="footer">
            <div class="footer-content" >
                <router-link to="/" exact class="footer-router" active-class="footer-router-active">
                    <img class="footer-icon nomal" src="../assets/images/tabbar_home_normal@2x.png" alt="首页">
                    <img class="footer-icon active" src="../assets/images/tabbar_home_select@2x.png" alt="首页">
                    <p class="footer-text">果师兄</p>
                </router-link>
                <!-- <router-link to="/team"  class="footer-router" active-class="footer-router-active">
                    <img  class="footer-icon nomal" src="../assets/images/tabbar_team_normal@2x.png" alt="意见反馈">
                    <img  class="footer-icon active" src="../assets/images/tabbar_team_select@2x.png" alt="意见反馈">
                    <p class="footer-text">团队</p>
                </router-link>
                <router-link to="/consult"  class="footer-router" active-class="footer-router-active">
                  <img  class="footer-icon nomal" src="../assets/images/tabbar_consult_normal@2x.png" alt="咨询">
                  <img  class="footer-icon active" src="../assets/images/tabbar_consult_select@2x.png" alt="咨询">
                  <p class="footer-text">咨询</p>
                </router-link> -->
                <router-link to="/orderList" exact class="footer-router" active-class="footer-router-active">
                    <img  class="footer-icon nomal" src="../assets/images/tabbar_order_normal@2x.png" alt="关于我们">
                    <img  class="footer-icon active" src="../assets/images/tabbar_order_select@2x.png" alt="关于我们">
                    <p class="footer-text">订单</p>
                </router-link>
                <router-link to="/my" exact class="footer-router" active-class="footer-router-active">
                    <img  class="footer-icon nomal" src="../assets/images/tabbar_mine_normal@2x.png" alt="关于我们">
                    <img  class="footer-icon active" src="../assets/images/tabbar_mine_select@2x.png" alt="关于我们">
                    <p class="footer-text">我的</p>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name:"footer_"
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue